import {
  CloudArrowUpIcon,
  LockClosedIcon,
  ServerIcon,
} from "@heroicons/react/20/solid";
import HomeInsTabs from "./HomeInsTabs";

export default function HomeInsurance() {
  return (
    <div className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:overflow-visible lg:px-0">
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <svg
          className="absolute left-[max(50%,25rem)] top-0 h-[64rem] w-[128rem] -translate-x-1/2 stroke-gray-200 [mask-image:radial-gradient(64rem_64rem_at_top,white,transparent)]"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="e813992c-7d03-4cc4-a2bd-151760b470a0"
              width={200}
              height={200}
              x="50%"
              y={-1}
              patternUnits="userSpaceOnUse"
            >
              <path d="M100 200V.5M.5 .5H200" fill="none" />
            </pattern>
          </defs>
          <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
            <path
              d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z"
              strokeWidth={0}
            />
          </svg>
          <rect
            width="100%"
            height="100%"
            strokeWidth={0}
            fill="url(#e813992c-7d03-4cc4-a2bd-151760b470a0)"
          />
        </svg>
      </div>
      <div className="mx-auto grid max-w-2xl  gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:items-start lg:gap-y-10">
        <div className=" lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-indigo-600">
                Protect What You Love
              </p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Home Insurance
              </h1>
            </div>
          </div>
        </div>

        <div className=" lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className=" text-base leading-7 text-gray-700 ">
              <p>
                Home insurance covers your house and belongings against life's
                unexpected events. It covers you against theft, damage by
                extreme weather, fire, and other losses. Generally, home
                insurance is categorised by two types of cover — buildings and
                contents. These can be combined or bought separately for total
                peace of mind, so the first step is deciding which option is
                better for you.
              </p>
              <h5 className="py-8">
                <strong>
                  What is covered on a home Insurance package insurance?
                </strong>
              </h5>
              <HomeInsTabs />
              <h5 className="py-8">
                <strong>Why choose Britam Home Shield Insurance</strong>
              </h5>
              <p className="pb-4">
                If you take Britam Homeshield you will enjoy a bigger, exciting
                and more relevant range of benefits at an affordable price;
                value for money. See below;
              </p>
              <ul className="list-disc list-inside">
                <li>
                  Cash back house painting Loyalty bonus if you insure with us
                  for 3 years, claim free
                </li>
                <li>
                  It is flexible allowing you the option for lower policy terms
                  between 5 and 12 Years and affordable.
                </li>
                <li>Discount of 7.5% if you pay 3 year premiums in advance.</li>
                <li>
                  Cash value for loss of rent while your building is under
                  refurbishment*.
                </li>
                <li>
                  Alternative accommodation in the event that your house is
                  uninhabitable following a peril.
                </li>
                <li>
                  Free medical expenses for guests and domestic employees
                  following a peril or attack by domestic animals up to stated
                  limit.
                </li>
                <li>
                  Reimbursement of costs incurred in extinguishing a fire
                  including cost of fire engines and municipal charges*
                </li>
                <li>
                  Compensation for loss or damage to goods contained in a
                  refrigerator caused by a breakdown or explosion of refrigerate
                  action unit or failure of the supply of electricity.
                </li>
                <li>
                  Consolation handbags benefits following a mugging or smash and
                  grab incident.
                </li>
                <li>Death benefit of Kesh 100,000 following a peril</li>
                <li>Personal Accident Cover for family</li>
                <li>
                  Trauma treatment and spa experience following a burglary or
                  fire incident
                </li>
                <li>
                  Golfers equipment, hole in one, Caddy’s Medial and Third Party
                  Liability
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      
    </div>
  );
}
